/** 已持久化的初始化状态优先于页面上的旧清单；完成前禁止修改。 */
export function stickerInitializationLocked(resource) {
  return !!resource && (resource.wallpaperType === 'stickers' || resource.assetType === 'stickers') &&
    (Number(resource.onOrOff) >= 10 || !!(resource.jsonConfig && resource.jsonConfig.stickerProcessing))
}

/** 失败（11）或失败后下线（0）时换了一个新 zip，可以直接保存重新初始化；其余未完成状态仍禁止保存。 */
export function stickerReuploadReady(resource) {
  const config = resource && resource.jsonConfig
  const processing = config && config.stickerProcessing
  const url = config && config.url
  return !!processing && [0, 11].includes(Number(resource.onOrOff)) &&
    typeof url === 'string' && url.endsWith('.zip') && url !== processing.zipUrl
}

/**
 * 编辑表单里的 zip 地址。初始化完成后后端把 url 挪到 processedZipUrl 并删掉 url；
 * 表单带回这个地址，后端比较后判定 zip 没换，不会重新初始化，也不会被「请上传资源文件」拦住。
 */
export function stickerEditZipUrl(jsonConfig) {
  if (!jsonConfig) return ''
  return jsonConfig.url || jsonConfig.processedZipUrl || ''
}

/** 部分成功仅用于显示进度，不能让运营接手未完成图片。 */
export function stickerEmojiProgress(resource) {
  const processing = resource && resource.jsonConfig && resource.jsonConfig.stickerProcessing
  const items = processing && processing.items ? Object.values(processing.items) : []
  return { total: items.length, done: items.filter(item => item.done === true).length }
}

/** 状态来自 onOrOff；具体工作由已保存事实推导，避免额外维护 stage。 */
export function stickerInitializationMessage(resource) {
  if (!stickerInitializationLocked(resource)) return ''
  const processing = resource.jsonConfig && resource.jsonConfig.stickerProcessing
  const progress = stickerEmojiProgress(resource)
  const work = processing && processing.converted
    ? (progress.total && progress.done === progress.total ? '清理原 ZIP 和旧文件' : 'AI emoji 识别')
    : '下载、转码和上传'
  if (Number(resource.onOrOff) === 0) return '资源已下架，初始化已暂停；可重试初始化、上传新的 zip 后保存、放弃本次初始化，或删除资源。'
  if (Number(resource.onOrOff) === 11) return `${work}未完成，自动尝试次数已耗尽；可人工重试、上传新的 zip 后保存，或放弃本次初始化。`
  if (Number(resource.onOrOff) === 12) return `${work}等待自动重试，已成功的结果会保留。`
  return `正在${work}，初始化和清理完成后才能编辑。`
}

/** 详情优先完整进度原因，避免备注长度限制掩盖失败；普通备注保持原用途。 */
export function stickerInitializationError(resource) {
  const processing = resource && resource.jsonConfig && resource.jsonConfig.stickerProcessing
  return processing && processing.error ? processing.error : ''
}
